import React from 'react'
import '../../styles/content/content.css'
import { useTranslation } from 'react-i18next'

function ScheduleSwitcher({ setSwitcher, switcher, customOnTextEnabled = false, customOnText = '', id = '' }) {
    const { t } = useTranslation()

    const ON = customOnTextEnabled ? customOnText : t('on')

    return (
        <button
            type="button"
            role="switch"
            aria-checked={!!switcher}
            className="flex flex-row justify-between items-center pointer bg-containerGray h-[40px] px-[15px] rounded-full coc-pill"
            onClick={() => setSwitcher(!switcher)}
            id="schedule-switcher"
        >
            <div className={`font-semibold text-lg mr-[12px] switch-label ${switcher ? 'text-[#5E639B]' : 'text-mudPurple'}`}>{switcher ? ON : t('off')}</div>
            <div className={`rounded-full w-[40px] p-1 flex flex-row items-center switch-track switcher-animation ${switcher ? 'bg-deepPurple' : 'bg-deselectPurple'}`} id={id}>
                <div className={`min-w-[16px] w-[16px] h-[16px] rounded-full switch-knob ${switcher ? 'bg-highlightColor' : 'bg-white'}`} data-on={!!switcher} />
            </div>
        </button>
    )
}

export default ScheduleSwitcher
